import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { usePageConfig } from '@/utils/useComponentConfig';
import { useRouter } from 'vue-router';
import { onMounted } from 'vue';
import { getOperationPlanApi, deleteOperationPlanApi } from '@/api/vodNew';
import PlanDetail from './planDetail/index.vue';
import { messageBox } from "@/utils/validate";
import { elMessage } from '@/utils';
import { debounce } from '@/utils/tools';
import { useI18n } from 'vue-i18n';
import { getDynamicPlanListApi, deleteDynamicPlanApi } from '@/api/topic';
import { themeTypeOptions } from '@/assets/config/dicts';
const __default__ = {
  name: 'OperatingPlan'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,

  setup(__props) {
    const router = useRouter();
    const tableRef = ref(null);
    const {
      t
    } = useI18n();
    onMounted(() => {
      getOperationPlanList();
    });
    const planDetail = reactive({
      visible: false,
      action: 'check',
      topicType: 'dynamic',
      data: {}
    });
    const searchConfig = reactive({
      formData: {
        name: '',
        type: 'dynamic'
      },
      formList: [{
        label: '方案名称',
        prop: 'name',
        widgetType: 'input'
      }, {
        label: '主题方式',
        prop: 'type',
        widgetType: 'Select',
        list: themeTypeOptions,
        change: val => {
          getOperationPlanList();
        }
      }],
      search: () => {}
    });
    const tableConfig = reactive({
      data: [],
      paginationConfig: usePageConfig(),
      listName: '运营方案',
      headerButtonsList: [{
        label: '新增',
        func: row => {
          // router.push('/operating/operating-plan/plan-action')
          planDetail.action = 'add';
          planDetail.visible = true;
          planDetail.data = row;
          planDetail.topicType = searchConfig.formData.type;
        }
      }],
      columnList: [{
        label: '序号',
        prop: 'no',
        width: 150
      }, {
        label: '运营方案名称',
        prop: 'name',
        sortable: 'custom'
      }, {
        label: '主题方式',
        prop: 'type',
        sortable: 'custom',
        formatter: val => val === 'static' ? t('静态主题') : t('动态主题')
      }, {
        label: '主题数量',
        prop: 'count',
        width: 200,
        sortable: 'custom'
      }, {
        label: '关联品牌',
        prop: 'relatedVodList',
        controller: () => searchConfig.formData.type === 'dynamic',
        formatter: val => val && val.length ? val.join(',') : ''
      }, {
        label: '描述',
        prop: 'description'
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        showOverflowTooltip: false,
        width: 200,
        buttonsList: [{
          label: '查看',
          func: row => {
            planDetail.action = 'check';
            planDetail.visible = true;
            planDetail.data = row;
            planDetail.topicType = searchConfig.formData.type === 'static' ? t('静态主题') : t('动态主题');
          }
        }, {
          label: '修改',
          func: row => {
            planDetail.action = 'edit';
            planDetail.visible = true;
            planDetail.data = row;
            planDetail.topicType = searchConfig.formData.type;
          },
          // 已关联方案时二次确认
          popConfirm: row => {
            if (!row.relatedVodList || !row.relatedVodList.length) return null;
            return {
              title: t('方案已关联品牌，修改方案将同步变更关联的品牌，确定修改？'),
              confirmText: t('确定'),
              cancelText: t('取消')
            };
          }
        }, {
          label: '删除',
          func: row => {
            messageBox('确定删除这条数据吗?').then(async () => {
              const {
                id
              } = row;
              const {
                code
              } = searchConfig.formData.type === 'dynamic' ? await deleteDynamicPlanApi(id) : await deleteOperationPlanApi({
                planId: id
              });

              if (code == 0) {
                elMessage('success', '删除成功');
                getOperationPlanList();
              }
            });
          },
          controller: row => {
            return !row.relatedVodList || !row.relatedVodList.length;
          }
        }]
      }],
      config: {
        loading: false
      }
    }); // 获取运营方案管理列表

    const getOperationPlanList = async params => {
      try {
        tableConfig.config.loading = true;
        const {
          page,
          limit
        } = tableConfig.paginationConfig;
        let reqParams = {
          pageNo: tableConfig.paginationConfig.page,
          pageSize: tableConfig.paginationConfig.limit,
          ...params,
          ...sortParams
        }; // 主题类型type不作为请求参数传给后台

        delete reqParams.type;
        const res = searchConfig.formData.type === 'dynamic' ? await getDynamicPlanListApi(reqParams) : await getOperationPlanApi(reqParams);

        if (res.code == 0) {
          tableConfig.data = res.data.map((item, index) => {
            return { ...item,
              no: (page - 1) * limit + index + 1,
              type: searchConfig.formData.type // 主题方式

            };
          });
          tableConfig.paginationConfig = {
            limit: res.pageSize,
            page: res.current,
            total: res.total
          };
        }
      } catch (error) {} finally {
        tableConfig.config.loading = false;
      }
    }; // 搜索事件


    const handleSearch = data => {
      tableConfig.paginationConfig.page = 1;
      getOperationPlanList(data);
    }; // 重置按钮事件


    const handleReset = () => {
      tableRef.value.commonTableRef.clearSort();
      tableConfig.paginationConfig.page = 1; // 重置为动态主题

      searchConfig.formData.type = 'dynamic';
      getOperationPlanList();
    };

    const sortParams = reactive({
      sortType: '',
      sortField: ''
    }); // 表格排序

    const handleSortChange = debounce(async params => {
      // console.log(params);
      if (params.order) {
        const sortType = params.order.replace('ending', '');
        sortParams.sortType = sortType;
        sortParams.sortField = params.prop;
        getOperationPlanList();
      } else {
        sortParams.sortType = '';
        sortParams.sortField = '';
        getOperationPlanList();
      }
    }, 200);

    const setOptionsBtnColumnWidth = width => {
      const findItem = tableConfig.columnList.find(item => item.label == '操作');
      findItem.width = width;
    };

    return (_ctx, _cache) => {
      const _component_SearchForm = _resolveComponent("SearchForm");

      const _component_Column = _resolveComponent("Column");

      const _component_CommonTable = _resolveComponent("CommonTable");

      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", null, [_createVNode(_component_SearchForm, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: handleSearch,
        onReset: handleReset
      }, null, 8, ["form-list", "form-data"]), _createVNode(_component_CommonTable, {
        "option-column-list": tableConfig.columnList,
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        ref_key: "tableRef",
        ref: tableRef,
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        options: tableConfig.config,
        onSortChange: _unref(handleSortChange),
        render: getOperationPlanList
      }, {
        default: _withCtx(() => [_createVNode(_component_Column, {
          "column-list": tableConfig.columnList
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["option-column-list", "table-config", "pagination-config", "options", "onSortChange"])], 512), [[_vShow, !planDetail.visible]]), _createVNode(PlanDetail, {
        modelValue: planDetail.visible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => planDetail.visible = $event),
        action: planDetail.action,
        sourceData: planDetail.data,
        topicType: planDetail.topicType,
        onUpdateList: _cache[1] || (_cache[1] = $event => getOperationPlanList())
      }, null, 8, ["modelValue", "action", "sourceData", "topicType"])], 64);
    };
  }

});